"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiSwitch = getMuiSwitch;
function getMuiSwitch(palette) {
  return {
    defaultProps: {
      // @ts-ignore missing in defaultProps type
      'data-testid': 'required'
    },
    styleOverrides: {
      root: {
        '&:focus': {
          backgroundColor: palette.grey[300],
          borderRadius: 12,
          boxShadow: '0px 0px 0px 4px rgba(24, 75, 157, 0.05)'
        },
        '&:hover': {
          backgroundColor: palette.grey[300],
          borderRadius: 12,
          boxShadow: '0px 0px 0px 4px rgba(24, 75, 157, 0.05)'
        },
        '.Mui-disabled .MuiSwitch-thumb': {
          backgroundColor: palette.grey[50],
          boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.1)'
        },
        '.Mui-disabled+ .MuiSwitch-track': {
          backgroundColor: "".concat(palette.grey[100], " !important")
        },
        '.Mui-disabled.Mui-checked .MuiSwitch-thumb': {
          backgroundColor: palette.common.white
        },
        '.Mui-disabled.Mui-checked+ .MuiSwitch-track': {
          backgroundColor: "".concat(palette.primary[100], " !important")
        },
        '.MuiSwitch-switchBase': {
          '&.Mui-checked': {
            transform: 'translateX(16px)'
          },
          padding: 2
        },
        '.MuiSwitch-thumb': {
          '&:focus': {
            boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.1)'
          },
          '&:hover': {
            boxShadow: '0px 1px 3px rgba(16, 24, 40, 0.1)'
          },
          backgroundColor: palette.common.white,
          boxShadow: '0px 1px 2px rgba(51, 51, 51, 0.05)',
          height: 16,
          width: 16
        },
        '.MuiSwitch-track': {
          '.Mui-checked': {
            backgroundColor: palette.primary[700]
          },
          backgroundColor: palette.grey[300],
          borderRadius: 12,
          height: 20,
          opacity: '1 !important',
          padding: 2,
          width: 36
        },
        height: 20,
        padding: 0,
        width: 36
      },
      sizeSmall: {
        '.MuiSwitch-switchBase': {
          '&.Mui-checked': {
            transform: 'translateX(12px)'
          }
        },
        '.MuiSwitch-thumb': {
          height: 12,
          width: 12
        },
        '.MuiSwitch-track': {
          height: 16,
          width: 28
        },
        height: 16,
        width: 28
      }
    }
  };
}